import React from "react";
import PublicLegalLayout from "./PublicLegalLayout";
import {
  PRIVACY_SECTIONS,
  PRIVACY_RIGHTS_COPY,
  LAST_UPDATED,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
} from "../../lib/legalCopy";

/**
 * Public Privacy Policy page. Mirrors the in-app Settings → Privacy view
 * verbatim so a Stripe / Apple reviewer can cross-check that the legal
 * commitments shown to logged-in users are identical to what we publish.
 */
export default function PrivacyPage() {
  return (
    <PublicLegalLayout title="Privacy Policy">
      <p className="text-navy-soft text-xs uppercase tracking-widest font-jakarta font-bold">
        Last updated: {LAST_UPDATED}
      </p>

      {PRIVACY_SECTIONS.map((section) => (
        <section
          key={section.heading}
          data-testid={`privacy-section-${section.heading.replace(/\s+/g, "-").toLowerCase()}`}
          className="bg-white rounded-3xl shadow-soft border border-navy/5 p-6 sm:p-7"
        >
          <h2 className="font-jakarta font-extrabold text-xl text-navy mb-3">
            {section.heading}
          </h2>
          {section.heading === "Your rights" ? (
            // Render the rights paragraph with the support email turned
            // into a real mailto link.
            <p>
              {PRIVACY_RIGHTS_COPY.split(SUPPORT_EMAIL)[0]}
              <a
                href={SUPPORT_MAILTO}
                data-testid="privacy-support-mailto"
                className="text-orange font-bold hover:underline"
              >
                {SUPPORT_EMAIL}
              </a>
              {PRIVACY_RIGHTS_COPY.split(SUPPORT_EMAIL)[1]}
            </p>
          ) : (
            <p>{section.body}</p>
          )}
        </section>
      ))}
    </PublicLegalLayout>
  );
}
